import { useCallback } from 'react';
import { reduxForm } from 'redux-form';
import { useTranslation } from 'react-i18next';

import { config } from 'app/config';
import { user } from 'services';
import { StyledField, ErrorMsg, required, itn, psrnsp } from 'libs/form';
import { ButtonContainer, Submit } from 'libs/ui';
import { LK } from './lk';

const SoleProprietorFormForm = (props) => {
  const { initialValues, handleSubmit, submitting, error } = props;
  const { t } = useTranslation();

  const rightUpdate = user.haveRight('clients.update');
  const requiredField = useCallback(required(t), [t]);
  const requiredItn = useCallback(itn(t), []);
  const requiredPsrnsp = useCallback(psrnsp(t), []);

  return (
    <form onSubmit={handleSubmit}>
      <ErrorMsg theme="dark" message={error} />

      <StyledField validate={requiredField} type="text" label={t('form.ФИО') + config.req} name="name" placeholder="Иванов Иван Иванович" />
      <StyledField type="date" label={t('form.Дата рождения')} name="birth_date" placeholder={t('form.08 11 2017')} className="shortfield" />
      <StyledField validate={requiredItn} mask="9999 9999 9999" type="text" label="ИНН" name="itn" placeholder="1234 4321 5643" />
      <StyledField validate={requiredPsrnsp} mask="9999 9999 9999 999" type="text" label="ОГРНИП" name="psrnsp" placeholder="4235 4556 7845 745" />
      <StyledField type="text" label={t('form.Паспорт')} name="passport" placeholder="04 05 990440" />
      <StyledField type="text" label={t('form.Кем выдан')} name="passport_issued_by" placeholder="Выдан УВД Приморского района г. Санкт-Петербург" />
      <StyledField type="date" label={t('form.Дата выдачи')} name="passport_when_issued" placeholder={t('form.08 11 2017')} className="shortfield" />
      <StyledField type="text" label={t('form.Код подразделения')} name="passport_department_code" placeholder="233 – 005" />
      {initialValues.id && <LK lk_login={initialValues.lk_login} />}
      {rightUpdate && (
        <ButtonContainer>
          <Submit disabled={submitting} />
        </ButtonContainer>
      )}
    </form>
  );
};

export const SoleProprietorForm = reduxForm({
  form: 'SoleProprietorForm',
})(SoleProprietorFormForm);
